import type { RouteObject } from "react-router-dom";
import { matchRoutes } from "react-router-dom";

import HomePage from "../pages/HomePage";
import TemplateListPage from "../pages/Main/TemplateListPage";
import TemplateCreatePage from "../pages/Main/TemplateCreatePage";
import FormCreatePage from "../pages/FormBuilder/FormCreatePage";
import FormViewPage from "../pages/FormBuilder/FormViewPage";
import CreateRequestPage from "../pages/Requests/CreateRequestPage";
import ListPage from "../pages/Requests/ListPage";
import ViewRequestPage from "../pages/Requests/ViewRequestPage";
import EditRequestPage from "../pages/Requests/EditRequestPage";
import MyApprovalsPage from "../pages/Approvals/MyApprovalsPage";
import DashboardPage from "../pages/Dashboard/DashboardPage";
import RequestListPage from "../pages/Requests/RequestListPage";
import MyRequestsListPage from "../pages/Requests/MyRequestsListPage";
import WorksPlanPage from "../pages/WorksPlan/WorksPlanPage";

/**
 * The pages that render inside the tabbed workspace. `useRoutes(routeObjects,
 * tabPath)` resolves each open tab to one of these, keeping its own params.
 */
export const routeObjects: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/templates", element: <TemplateListPage /> },
  { path: "/templates/create", element: <TemplateCreatePage /> },
  { path: "/forms/create", element: <FormCreatePage /> },
  { path: "/forms/view", element: <FormViewPage /> },
  { path: "/my-requests", element: <MyRequestsListPage /> },
  { path: "/my-approvals", element: <MyApprovalsPage /> },
  { path: "/analytics", element: <DashboardPage /> },
  { path: "/works-plan", element: <WorksPlanPage /> },
  { path: "/requests/list", element: <ListPage /> },
  { path: "/requests/edit/:id", element: <EditRequestPage /> },
  { path: "/requests/:shortName/create", element: <CreateRequestPage /> },
  { path: "/requests/:typeName/:shortName", element: <RequestListPage /> },
  { path: "/requests/:id", element: <ViewRequestPage /> },
  {
    path: "*",
    element: <div style={{ padding: 24 }}>Page not found</div>,
  },
];

// Default tab titles per route pattern. Dynamic pages refine these at runtime
// via useTabTitle().
const TITLE_BY_PATTERN: Record<string, string> = {
  "/": "Home",
  "/templates": "Templates",
  "/templates/create": "Create Template",
  "/forms/create": "Create Form",
  "/forms/view": "Form",
  "/my-requests": "My Requests",
  "/my-approvals": "My Approvals",
  "/analytics": "Analytics",
  "/works-plan": "Works Plan",
  "/requests/list": "Requests",
  "/requests/edit/:id": "Edit Request",
  "/requests/:shortName/create": "Create Request",
  "/requests/:typeName/:shortName": "Requests",
  "/requests/:id": "Request",
};

/** Derives a sensible default title for a given URL path. */
export function deriveTabTitle(pathname: string): string {
  const matches = matchRoutes(routeObjects, pathname);
  const leaf = matches?.[matches.length - 1];
  const pattern = leaf?.route.path;
  return (pattern && TITLE_BY_PATTERN[pattern]) || "Page";
}
